import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Grid } from '@mui/system';
import LinksInputTemplate from './LinksInputTemplate';
import { DateInput, InputList, NumberInput, TextArea, Dropdown } from 'framework/form';
import { CLOSEOUT_STATUS_OPTIONS } from '../constants';

const ProjectCloseoutForm = () => {
  return (
    <Stack gap={2}>
      <Typography variant="h6">Project closeout</Typography>
      <Grid container spacing={2} size={12} direction={'column'}>
        <Grid size={3}>
          <Dropdown source={'status'} label="Project status" options={CLOSEOUT_STATUS_OPTIONS} />
        </Grid>
        <Grid container>
          <Grid size={3}>
            <NumberInput source={'totalHoursSpent'} label="Final total budget spent, hours" />
          </Grid>
          <Grid size={3}>
            <DateInput source={'deliveryDate'} label="Final date of delivery" />
          </Grid>
        </Grid>
        <InputList
          inputTemplate={LinksInputTemplate}
          source="links"
          addText="Add link"
          defaultValue={{}}
          maxFields={100}
          label="Links"
          sx={{ '& .removable-input ': { m: 0 } }}
        />
        <TextArea source={'text'} label="Note" />
      </Grid>
    </Stack>
  );
};

export default ProjectCloseoutForm;
